import React__default from 'react';
import { useSearchContext } from '../../searchContext/SearchContextProvider.js';
import { ANALYTICS_SECTION_CLASS, ANALYTICS_RESULT_CLASS } from '../../util/analyticsConstants.js';

var SectionAnalyticsWrapper = function SectionAnalyticsWrapper(_ref) {
  var children = _ref.children,
    taxonomyId = _ref.taxonomyId,
    sectionName = _ref.sectionName,
    analyticsListSection = _ref.analyticsListSection;
  var _useSearchContext = useSearchContext(),
    query = _useSearchContext.query,
    results = _useSearchContext.results,
    allResultsReturned = _useSearchContext.allResultsReturned,
    applicationName = _useSearchContext.applicationName,
    sectionTrackingDetails = _useSearchContext.sectionTrackingDetails;
  var sectionRef = React__default.useRef(null);
  var trackingEvent = {
    query: query,
    sectionName: sectionName,
    location: window.location.pathname,
    applicationName: applicationName
  };
  var getRenderedResultIds = function getRenderedResultIds(section) {
    return Array.from(section.getElementsByClassName(ANALYTICS_RESULT_CLASS)).map(function (element) {
      return element.getAttribute('data-result-id');
    });
  };
  var fireSearchResultSectionWhenReady = function fireSearchResultSectionWhenReady(section, resultsFound) {
    var attemptCount = 1;
    var resultRenderInterval = setInterval(function () {
      if (attemptCount >= 20) {
        //stop trying after 1 second
        clearInterval(resultRenderInterval);
        return;
      }
      attemptCount++;
      var renderedResultIds = getRenderedResultIds(section);
      if (!renderedResultIds.length) return;
      trackingEvent['shownResultsInSection'] = resultsFound.filter(function (result) {
        return renderedResultIds.includes(result.id);
      });
      window.tracking.track('Search Result Section', trackingEvent);
      clearInterval(resultRenderInterval);
    }, 50);
  };
  React__default.useEffect(function () {
    if (window.tracking && allResultsReturned) {
      var _results$taxonomyId, _sectionTrackingDetai;
      var resultsWithTypos = 0;
      var resultsFound = (_results$taxonomyId = results[taxonomyId]) === null || _results$taxonomyId === void 0 ? void 0 : _results$taxonomyId.map(function (result) {
        var _algoliaResult, _algoliaResult$rankin, _algoliaResult2;
        if (result !== null && result !== void 0 && result.algoliaResult && (_algoliaResult = result.algoliaResult) !== null && _algoliaResult !== void 0 && _algoliaResult.shouldHide) {
          return undefined;
        }
        resultsWithTypos += ((_algoliaResult$rankin = result === null || result === void 0 || (_algoliaResult2 = result.algoliaResult) === null || _algoliaResult2 === void 0 || (_algoliaResult2 = _algoliaResult2.rankingInfo) === null || _algoliaResult2 === void 0 ? void 0 : _algoliaResult2.nbTypos) !== null && _algoliaResult$rankin !== void 0 ? _algoliaResult$rankin : 0 > 0) ? 1 : 0;
        return {
          resultSource: result === null || result === void 0 ? void 0 : result.resultSource,
          id: result === null || result === void 0 ? void 0 : result.id
        };
      }).filter(function (result) {
        return result;
      });
      if (!resultsFound) {
        return;
      }
      trackingEvent['resultsInSection'] = resultsFound.slice(0, 200); //Too many results can exceed Segment's event size limit
      trackingEvent['rulesApplied'] = (_sectionTrackingDetai = sectionTrackingDetails[taxonomyId]) === null || _sectionTrackingDetai === void 0 ? void 0 : _sectionTrackingDetai.rules;
      trackingEvent['resultsWithTyposCount'] = resultsWithTypos;
      trackingEvent['totalResultCount'] = resultsFound.length;
      var section = sectionRef.current;
      var renderedResultIds = getRenderedResultIds(section);
      if (!renderedResultIds.length) {
        fireSearchResultSectionWhenReady(section, resultsFound);
      } else {
        trackingEvent['shownResultsInSection'] = resultsFound.filter(function (result) {
          return renderedResultIds.includes(result.id);
        });
        window.tracking.track('Search Result Section', trackingEvent);
      }
    }
  }, [allResultsReturned]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: ANALYTICS_SECTION_CLASS,
    "data-search-analytics-section-name": sectionName,
    "data-search-analytics-list-name": analyticsListSection || sectionName,
    ref: sectionRef
  }, children);
};

export { SectionAnalyticsWrapper as default };
//# sourceMappingURL=SearchResultSectionAnalyticsWrapper.js.map
